import React from "react";
import { Route, Routes } from "react-router-dom";
import PickWaves from "./waves";
import Pickers from "./pickers";
import Shortages from "./shortages";

const Orderpicking = () => (
  <Routes>
    <Route path="waves" element={<PickWaves />} />
    <Route path="pickers" element={<Pickers />} />
    <Route path="shortages" element={<Shortages />} />
  </Routes>
);

export default Orderpicking;
